module.exports = __webpack_public_path__ + "static/media/Linda_Hernandez_Front.ef1d2864.png";